import { AccordionTrigger } from '@common/components/Accordion/AccordionTrigger';
import { DrawingPinFilledIcon, EraserIcon } from '@radix-ui/react-icons';
import { Box, Flex, IconButton } from '@radix-ui/themes';
import { Accordion } from 'radix-ui';
import { PropsWithChildren } from 'react';

import styles from './SectionWrapper.module.css';

interface SectionWrapperProps extends PropsWithChildren {
    facetKey: string;
    label: string;
    onClear: () => void;
    hasActiveFilter: boolean;
    onUnpin: () => void;
    canUnpin: boolean;
}

export const SectionWrapper = ({
    facetKey,
    label,
    onClear,
    hasActiveFilter,
    children,
    onUnpin,
    canUnpin,
}: SectionWrapperProps) => (
    <Accordion.Item className={styles.accordionItem} value={facetKey}>
        <Accordion.Header asChild>
            <Box>
                <AccordionTrigger label={label}>
                    <Flex gap={'2'}>
                        {canUnpin && (
                            <IconButton
                                variant='ghost'
                                size='1'
                                ml={'auto'}
                                radius={'full'}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onUnpin();
                                }}
                            >
                                <DrawingPinFilledIcon />
                            </IconButton>
                        )}
                        {hasActiveFilter && (
                            <Flex
                                width={'100%'}
                                align={'center'}
                                justify={'between'}
                            >
                                <Box className={styles.activeFilterDot} />

                                <IconButton
                                    size={'1'}
                                    variant={'ghost'}
                                    radius={'full'}
                                    color={'red'}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onClear();
                                    }}
                                >
                                    <EraserIcon cursor={'pointer'} />
                                </IconButton>
                            </Flex>
                        )}
                    </Flex>
                </AccordionTrigger>
            </Box>
        </Accordion.Header>

        <Accordion.Content className={styles.accordionContent} asChild>
            <Box p={'3'}>{children}</Box>
        </Accordion.Content>
    </Accordion.Item>
);
